import React from "react";
import cname from "../../style.module.scss";
import { INFO_TAB_TYPES } from "../../Spectrophotometer.utils";
import { HowItWorkImage } from "../../SpectrophotometerImages";
import { ContentParts } from "../ContentParts";
import { ContentTheMath } from "../TheMath";

export const Content = (props: { type: string }) => {
  if (props.type === INFO_TAB_TYPES.PARTS) {
    return <ContentParts />;
  } else if (props.type === INFO_TAB_TYPES.THE_MATH) {
    return <ContentTheMath />;
  } else {
    return <HowItWorksContent />;
  }
};

Content.defaultProp = {
  type: INFO_TAB_TYPES.HOW_IT_WORKS,
};

function HowItWorksContent() {
  return (
    <div className={cname.content_how}>
      <div className={cname.content_how_image}>
        <HowItWorkImage />
      </div>
      <div className={cname.content_how_content}>
        <p>
          <ol type="1">
            <li>
              <strong>Light Source. </strong>The spectrophotometer consists of a
              light source that emits light typically ranging from UV to visible
              light. Certain spectrophotometers have extended light ranges into
              the near-infrared spectrum.
            </li>
            <li>
              <strong>Lens. </strong>
              The light gets focused by a lens.
            </li>
            <li>
              <strong>Prism. </strong>
              The focused light gets refracted by a monochromator, often a
              prism.
            </li>
            <li>
              <strong>Wavelength selector. </strong>A wavelength selector allows
              us to choose a particular wavelength.
            </li>
            <li>
              <strong>Cuvette with sample. </strong>
              The selected wavelength then can pass through a cuvette that
              contains the sample. Light is measured (as the number of photons
              detected) twice by the spectrophotometer: first, as the entering
              light (denoted as
              <i>
                &nbsp;I<sub>0</sub>&nbsp;
              </i>
              ), and second, as the light exiting the sample (denoted as{" "}
              <i>&nbsp;I&nbsp;</i>).
            </li>
            <li>
              <strong>The light detector. </strong>
              The light detector measures how much light is transmitted through
              the cuvette that was not absorbed by the sample.
            </li>
            <li>
              <strong>Absorbance display. </strong>
              After calculating how much light is absorbed, the absorbance value
              is displayed.
            </li>
          </ol>
        </p>
      </div>
    </div>
  );
}
